import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "container-sm product-text"
};
const _hoisted_2 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "seperator" }, null, -1);
const _hoisted_4 = [
    _hoisted_3
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    return (_ctx.texte?.items && _ctx.texte.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(['col-12 p-3 category__category-textbox', _ctx.location === 'bottom' ? 'mt-2' : 'mb-2'])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.texte.items, (text) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        _createVNode(_component_g_dynamic_html, {
                            template: text.text
                        }, null, 8, ["template"]),
                        (text.seperator)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                            : _createCommentVNode("", true)
                    ], 64));
                }), 256))
            ], 2)
        ]))
        : _createCommentVNode("", true);
}
